;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"d0a2d7503580800c5694c6e3772adda2a8906916"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import * as Sentry from '@sentry/nextjs';

import { CORE_ERROR_PATTERNS, createBeforeSend } from '@zep/sentry';

import baseOptions from '../../sentry.base.config';

Sentry.init({
  ...baseOptions,
  beforeSend: createBeforeSend({
    ignorePatterns: [...CORE_ERROR_PATTERNS],
  }),
});
